import React from "react";
import Breadcrumb from "../components/Breadcrumb";

export default function HealthtechSpecificSolutions() {
  return (
    <>
      <Breadcrumb title="HealthTech Specific Solutions" />

      <div className="page-service-single">
        <div className="container">
          {/* Main Content */}
          <div className="row">
            <div className="col-lg-12">
              <div className="service-single-content">
                {/* Featured Image */}
                <div className="service-featured-image">
                  <figure className="image-anime reveal">
                    <img
                      src="/assets/images/healthtech.png"
                      alt="HealthTech Specific Solutions"
                      loading="lazy"
                    />
                  </figure>
                </div>

                {/* Entry Content */}
                <div className="service-entry">
                  <p className="wow fadeInUp" data-wow-delay="0.25s">
                    We deliver tailored HealthTech solutions designed for
                    healthcare providers, pharma companies, and life sciences
                    organizations. Our solutions ensure compliance, data
                    security, scalability, and measurable clinical and business
                    outcomes.
                  </p>

                  <h4 className="mb-2">What we do</h4>
                  <ul>
                    <li>Custom HealthTech platform development</li>
                    <li>Clinical & healthcare workflow digitization</li>
                    <li>Secure patient & medical data systems</li>
                    <li>Healthcare analytics & decision support</li>
                  </ul>

                  <h4 className="mb-2 mt-2">Value we create</h4>
                  <ul>
                    <li>Improved care delivery & operational efficiency</li>
                    <li>Regulatory-compliant digital platforms</li>
                    <li>Scalable, future-ready health ecosystems</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Service Blocks */}
          <div className="row">
            <ServiceBlock
              title="Healthcare Application Development"
              items={[
                "Hospital & clinic management systems",
                "Patient portals & engagement platforms",
                "Telemedicine & virtual care solutions",
                "Appointment scheduling & care workflows",
              ]}
            />

            <ServiceBlock
              title="Pharma & Life Sciences Solutions"
              items={[
                "Product lifecycle & data management",
                "Medical information platforms",
                "Clinical trial data systems",
                "Pharmacovigilance support tools",
              ]}
            />

            <ServiceBlock
              title="Compliance & Security"
              items={[
                "HIPAA & GDPR-aligned system design",
                "Role-based access control",
                "Audit trails & data encryption",
                "Secure cloud infrastructure",
              ]}
            />

            <ServiceBlock
              title="Health Data Analytics"
              items={[
                "Clinical dashboards & KPIs",
                "Patient outcome analytics",
                "Operational & financial insights",
                "Real-time reporting systems",
              ]}
            />

            <ServiceBlock
              title="Interoperability & Integrations"
              items={[
                "EHR / EMR integration",
                "HL7 / FHIR-based integrations",
                "API connectivity with medical systems",
                "Device & IoT healthcare integrations",
              ]}
            />

            <ServiceBlock
              title="AI & Automation in Healthcare"
              items={[
                "Clinical decision support systems",
                "AI-driven diagnostics assistance",
                "Predictive analytics for patient care",
                "Workflow automation & alerts",
              ]}
            />
          </div>
        </div>
      </div>
    </>
  );
}

/* ✅ Reusable Service Block */
function ServiceBlock({ title, items }) {
  return (
    <div className="col-lg-4">
      <div className="service-sidebar">
        <div className="services-list-box wow fadeInUp" data-wow-delay="0.5s">
          <h3>{title}</h3>
          <ul>
            {items.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
